export enum PageRoute {
  login = "login",
  profileForm = "profile-form",
  schoolSelect = "school-select",
  orgSelect = "org-select",
  orgCreate = "org-create",
  location = "location",
  noSubscription = "no-subscription",
  shopifyNoSubscription = "shopify-no-subscription",
}
